<template>
  <div class="detail-wrap">
    <div class="bg"></div>
    <van-tabs v-model="active" background="transparent" color="#fff" title-inactive-color="rgba(255,255,255,.5)" title-active-color="#fff" line-width="18" line-height="2">
      <van-tab title="业绩"><service :active="active"/></van-tab>
      <van-tab title="推销"><sell :active="active"/></van-tab>
      <van-tab title="售卡"><sellCard :active="active"/></van-tab>
    </van-tabs>
  </div>
</template>

<script>

export default {
  name: 'detail',
  components: {
    'service':() => import('./components/service'),
    'sell':() => import('./components/sell'),
    'sellCard':() => import('./components/sellCard')
  },
  filters: {},
  mixins: [],
  props: {},
  data () {
    return {
      active:0,
    }
  },
  computed: {},
  watch: {},
  created () {
  },
  mounted () {

  },
  methods: {
  }
}

</script>

<style lang="scss" scoped>
.detail-wrap {
  position: relative;
  .bg{
    height: 420px;
    width: 100%;
    // position: fixed;
    position: absolute;
    top: 0;
    background: url("~@/assets/images/achievement-Bg.png") no-repeat top/100%;
    background-position:0 -354px;
  }
  /deep/ .van-tabs__wrap{
    border-bottom: 1px solid rgba(240,240,240,.15);
    .van-tab{
      font-size: 28px;
    }
    .van-tabs__nav{

      .van-tabs__line{
        bottom:45px;
        .van-tab__text--ellipsis {
          font-size: 90px;
        }
      }
    }
  }
}
</style>
